import React from 'react';

import { Email } from '@oca/icons';
import { i18n } from '@lib/i18n';
import { t } from '@lingui/macro';

export const routes = [
  {
    path: '/email',
    navigation: { name: i18n._(t`Email`), icon: <Email /> },
    component: () => window.location.replace('https://mail.ocasia.online'),
    target: '_blank',
  },
];
